import SocialMedia from './SocialMedia'
import HeroSlider from './HeroSlider'
import SolutionsSlider from './SolutionsSlider'
import NewsSlider from './NewsSlider'
import Accordion from './Accordion'
import Map from './Map'
import References from './References'
import Ressources from './Ressources'
import Title from './Title'

const blockList = [
  {
    name: 'social-media',
    Class: SocialMedia
  },
  {
    name: 'home-cover',
    Class: HeroSlider
  },
  {
    name: 'solutions__slider',
    Class: SolutionsSlider
  },
  {
    name: 'latest-news',
    Class: NewsSlider
  },
  {
    name: 'accordion',
    Class: Accordion
  },
  {
    name: 'custom-map',
    Class: Map
  },
  {
    name: 'references',
    Class: References
  },
  {
    name: 'ressources',
    Class: Ressources
  },
  {
    name: 'heading',
    Class: Title
  }
]

export default blockList



// WEBPACK FOOTER //
// ./scripts/blocks/blockList.js